import { render, staticRenderFns } from "./FichaClinica.vue?vue&type=template&id=2797f816&"
import script from "./FichaClinica.vue?vue&type=script&lang=js&"
export * from "./FichaClinica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports